import {
  rolledOutCountries
} from "./chunk-45SK4NFQ.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getAISearchEnabledOutCountries/getAISearchEnabledOutCountries.ts
async function getAISearchEnabledOutCountries(apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getAISearchEnabledOutCountries");
    const data = await rolledOutCountries(_apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getAISearchEnabledOutCountries
};
